export const starCalculator = (initTime, timeTaken, moveCount) => {
  const moveAllowence = 5;
  const gameTotal = initTime - timeTaken - moveCount;
  const star2Min = initTime / 3 - moveAllowence;
  const star3Min = star2Min * 2 - moveAllowence;

  if (gameTotal >= star2Min && gameTotal < star3Min) {
    return 2;
  }
  if (gameTotal >= star3Min) {
    return 3;
  } 
    return 1;
  
};



// WEBPACK FOOTER //
// ./src/helpers/starCalculator.js